import { render, staticRenderFns } from "./PlaceTypeBadge.vue?vue&type=template&id=f1312a38&"
import script from "./PlaceTypeBadge.vue?vue&type=script&lang=js&"
export * from "./PlaceTypeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports